<template>
    <modal
        name="add-new-watchlist"
        height="auto"
        :adaptive="true"
    >
        <div class="modal">
            <h3 class="modal__title" v-html="$t('ModalAddNewWatchlist.name_new_watchlist')"></h3>
            <div class="modal__content">
                <TotemInput type=text v-model="newWatchlistName" :placeholder="$t('ModalAddNewWatchlist.new_watchlist')" class="modal__input"></TotemInput>
                <TotemButton
                    @click="addNewWatchlist"
                    class="-margin-left"
                    :disabled="isWatchListNameEmpty || isWatchListNameTooLong"
                    :label="$t('ModalAddNewWatchlist.create_watchlist')"
                />
            </div>
            <span v-if="isWatchListNameEmpty" class="modal__empty-watchlist-name-notification" v-html="$t('ModalAddNewWatchlist.name_new_watchlist_notification')"></span>
            <span v-if="isWatchListNameTooLong" class="modal__empty-watchlist-name-notification" v-html="$t('ModalAddNewWatchlist.too_long_name_notification')"></span>
        </div>
    </modal>
</template>

<script>
    export default {
        data () {
            return {
                newWatchlistName: '',
                courseId: null,
                addInProgress: false
            }
        },
        methods: {
            async addNewWatchlist () {
                this.addInProgress = true
                if (this.newWatchlistName === '' || this.isWatchListNameTooLong) {
                    return
                }
                await this.$store.dispatch('Watchlists/assignNewWatchlistName', this.newWatchlistName)
                await this.$store.dispatch('Watchlists/createNewWatchList')
                this.addInProgress = false
                this.newWatchlistName = ''
                this.$emit('new-watchlist-added')
            },
            beforeOpen (event) {
                return this.$store.dispatch('Watchlists/toggleModal', true)
            },
            beforeClose (event) {
                return this.$store.dispatch('Watchlists/toggleModal', false)
            }
        },
        computed: {
            isWatchListNameEmpty () {
                return this.newWatchlistName === '' && this.addInProgress
            },
            isWatchListNameTooLong () {
                return this.newWatchlistName.length > 255
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        padding: 60px 40px;
        display: flex;
        flex-direction: column;

        &__title {
            display: flex;
            margin: 0 0 40px;
            justify-content: center;
        }

        &__content {
            display: flex;
        }

        &__input {
            flex: 1;
        }

        &__empty-watchlist-name-notification {
            color: $red_salsa;
            justify-content: start;
            align-items: start;
            margin: 5px 10px 0;
        }
    }
</style>
